'use client';

import Navigation from '@components/header/components/navigation';
import { default as NextLink } from 'next/link';
import type { ReactElement, ReactNode } from 'react';
import type { NavigationLink } from 'types/navigation-link';
import { validateString } from 'utils/validate-string';

import styles from './header.module.scss';

interface HeaderProps {
  readonly logo: ReactNode;
  readonly links: NavigationLink[];
}

const rootClassName = validateString(styles.root);
const contentClass = validateString(styles.content);
const logoClassName = validateString(styles.logo);

function Header({ links, logo }: HeaderProps): ReactElement {
  return (
    <header className={rootClassName}>
      <div className={contentClass}>
        <NextLink aria-label="Home" className={logoClassName} href="/">
          {logo}
        </NextLink>
        <Navigation links={links} />
      </div>
    </header>
  );
}

export default Header;
